import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider } from '@mui/material';
import HelpSidebar from './HelpSidebar';

interface ImportedLeaveHelpSidebarProps {
  isExpanded: boolean;
  onToggle: () => void;
}

export const ImportedLeaveHelpSidebar: React.FC<ImportedLeaveHelpSidebarProps> = ({
  isExpanded,
  onToggle,
}) => (
  <HelpSidebar isExpanded={isExpanded} onToggle={onToggle} title="Imported Leave Help">
    <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary', fontStyle: 'italic' }}>
      Correct historic leave taken that was imported from spreadsheets (for example FY2026). These rows
      feed <strong>My Leave</strong>, <strong>Team Leave</strong>, and <strong>Organisation Leave</strong>{' '}
      alongside approved leave requests. You cannot add rows here — capture new leave through normal
      requests or <strong>Book leave on behalf</strong> on Organisation Leave.
    </Typography>

    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
      SEARCH AND FILTERS
    </Typography>
    <List dense sx={{ mb: 2 }}>
      <ListItem sx={{ px: 0, py: 0.5 }}>
        <ListItemText
          primary="Find rows"
          secondary="Search by employee name or employee number. Filter by period year and leave type. Sort any column using the header icons."
          primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
          secondaryTypographyProps={{ variant: 'body2' }}
        />
      </ListItem>
    </List>

    <Divider sx={{ my: 2 }} />

    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
      EDIT AND DELETE
    </Typography>
    <List dense sx={{ mb: 2 }}>
      <ListItem sx={{ px: 0, py: 0.5 }}>
        <ListItemText
          primary="Edit days taken"
          secondary="Only days taken can be changed. Leave type, year, and month stay as imported. To remove a wrong row entirely, delete it and book the correct leave in the app."
          primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
          secondaryTypographyProps={{ variant: 'body2' }}
        />
      </ListItem>
      <ListItem sx={{ px: 0, py: 0.5 }}>
        <ListItemText
          primary="Delete"
          secondary="Removes the imported row immediately from leave reports (hard delete). Confirm in the dialog. This cannot be undone except by re-importing from the spreadsheet if you still have it."
          primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
          secondaryTypographyProps={{ variant: 'body2' }}
        />
      </ListItem>
    </List>

    <Divider sx={{ my: 2 }} />

    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1, color: 'primary.main' }}>
      AUDIT TRAIL
    </Typography>
    <List dense>
      <ListItem sx={{ px: 0, py: 0.5 }}>
        <ListItemText
          primary="Leave audit log"
          secondary='Every edit and delete is recorded under Audit logs → Leave. Filter by "Imported Leave Balance Updated" or "Imported Leave Balance Deleted".'
          primaryTypographyProps={{ variant: 'body2', fontWeight: 600 }}
          secondaryTypographyProps={{ variant: 'body2' }}
        />
      </ListItem>
    </List>
  </HelpSidebar>
);

export default ImportedLeaveHelpSidebar;
